import { ReactiveController, ReactiveControllerHost } from 'lit';
import { StateEvent } from '@src/lit/store/state-event.js';
import { State } from '@src/lit/store/state.js';
/**
 * A reactive-controller holding a state
 */

type StateCallback = () => void;

export class StateController<T extends State>
implements ReactiveController {
  callback: StateCallback;

  constructor(
    protected host: ReactiveControllerHost,
    private state: T,
    cb?: StateCallback,
  ) {
    this.callback = cb || (() => this.host.requestUpdate());
    this.host.addController(this);
  }

  hostConnected(): void {
    this.state.addEventListener(StateEvent.eventName, this.callback);
    this.callback();
  }
  hostDisconnected(): void {
    this.state.removeEventListener(StateEvent.eventName, this.callback);
  }
}
